import { createBreakpoints } from "@chakra-ui/theme-tools";

interface BreakpointDefinitions {
  [key: string]: string;
  sm: string;
  "2sm": string;
  md: string;
  lg: string;
  xl: string;
  "2xl": string;
  "3xl": string;
}

const breakpointDefinitions: BreakpointDefinitions = {
  sm: "320px",
  "2sm": "380px",
  md: "768px",
  lg: "960px",
  xl: "1200px",
  "2xl": "1600px",
  "3xl": "1920px",
};

export const breakpoints = createBreakpoints(breakpointDefinitions);
